/**
 * Converts a string to Title Case, preserving specific acronyms and exceptions.
 * Default exceptions include common acronyms like "USA", "IPA", etc.
 */

const DEFAULT_EXCEPTIONS = [
  "CA",
  "Friuli-Venezia",
  "IPA",
  "Trentino-Alto",
  "TX",
  "US",
  "USA",
  "U.S."
];

/**
 * Converts a string to Title Case, preserving exceptions and skipping numeric-containing words.
 * @param input The input string to convert.
 * @param customExceptions Optional array of custom exceptions to override default list.
 * @returns A title-cased string with exceptions applied.
 */
export function toTitleCase(
  input: string,
  customExceptions?: string[]
): string {
  const exceptions = customExceptions ?? DEFAULT_EXCEPTIONS;

  const exceptionsMap = new Map<string, string>(
    exceptions.map((e) => [e.toLowerCase(), e])
  );

  return input
    .split(" ")
    .map((word) => {
      const cleaned = word.toLowerCase();

      // Preserve exceptions
      if (exceptionsMap.has(cleaned)) {
        return exceptionsMap.get(cleaned)!;
      }

      // Preserve words with numbers (e.g., 18ML, 750mL)
      if (/\d/.test(word)) {
        return word;
      }

      // Otherwise, Title Case it
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
